<template>
    <div class="room humidity-list-room" v-loading="pageLoading" ref="room">
        <RefreshBlock @refreshData="refreshData"></RefreshBlock>
        <div class="room-title">
            <span>{{ pageTitle }}</span>
        </div>

        <div class="humidity-list-container">
            <div v-for="(group, groupIndex) in humidityGroupList" :key="groupIndex" class="humidity-list-group"
                v-loading="stationIdLoadingDict[group.stationId]">
                <div class="humidity-group-name"> <span>{{ group.groupName }}</span></div>
                <div v-for="(item, itemIndex) in group.itemList" :key="itemIndex" class="humidity-list-item">
                    <SwitchStatusValue class="double-value-switch" v-if="item.deviceType === 'VALUE_SAME_LINE'"
                        :title="item.deviceName" :series="itemIdSeriesDict[item.itemId]">
                    </SwitchStatusValue>
                    <SwitchStatus v-if="item.deviceType === 'SWITCH' || item.deviceType === 'SWITCH_MALFUNCTION'"
                        :title="item.deviceName" :series="itemIdSeriesDict[item.itemId]">
                    </SwitchStatus>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    name: "SimpleCurrentData",
    data() {
        return {
            timer: null,
            tableData: [],
            pageLoading: false,
            shownewUser: false,
            checkUserId: "",
            totalCount: 1,
            currentPage: 1,
            pageSize: 10,
            bridgeId: "",
            bridgeName: "",
            bridgeHasErrorRecord: false,
            bridgeTranslateDict: {},
            deviceTranslateDict: {},
            deviceNameReplaceList: ["状态", "(枚举)"],
            tableMaxHeight: 777,
            clientHeight: 0,
            pageStyle: {},
            paginationHeight: 70,
            firstIndex: 0,
            lastIndex: 0,
            historyScenarioCurrentGroupNameList: [],

            humidityGroupList: [],
            stationIdMergedStationIdListDict: {},
            stationIdLoadingDict: {},
            itemIdSeriesDict: {},
            deviceIdDataDict: {},
            deviceIdItemNameDict: {},

            routeBridgeId: "",
            includePower: false,
            deviceIdDeviceNameDict: {},
            stationList: [],
            sortByItemCount: false,

            rowList_all: [],
            rowList_current: [],

            dataList_all: [],
            dataList_humidity: [],
            dataList_temperature: [],
            dataList_pressure: [],
            dataList_flow: [],
            dataList_volume: [],
            dataList_runningTime: [],
            dataList_power: [],
            dataList_others: [],
        };
    },
    computed: {
        ...mapGetters({
            isAdmin: "getIsAdmin",
            bridgeList: "getBridgeList",
        }),
        pageTitle() {
            let result = this.bridgeName + "实时";
            if (this.includePower) {
                result += "湿度与能耗";
            }
            else {
                result += "湿度";
            }
            result += "数据";

            return result;
        },
    },
    mounted() {
        this.pageLoading = true;

        this.initializeAndGetData();
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    watch: {
        clientHeight(newVal, oldVal) {
            this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
        },
        totalCount() {
            this.$nextTick().then(() => {
                this.pageStyle = {
                    left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
                };
            });
        },
        $route(route) {
            if (this.$route.query.bridgeId !== this.routeBridgeId) {
                this.initializeAndGetData();
            }
            if (this.$route.query.includePower !== this.includePower) {
                this.initializeAndGetData();
            }
        },
        selectedDataType() {
            this.dataTypeOnChange();
        },
        selectedStation() {
            this.pageLoading = true;
            this.currentPage = 1;
            this.getSimpleHumidityData();
        },
    },
    methods: {
        initializeAndGetData() {
            this.pageLoading = true;
            if (this.timer) {
                clearInterval(this.timer);
            }

            this.humidityGroupList = [];
            this.bridgeName = "";

            this.routeBridgeId = this.$route.query.bridgeId;
            this.includePower = this.$route.query.includePower;
            this.sortByItemCount = this.$route.query.sortByItemCount;

            let routeBridgeIdConfirmed = false;
            this.bridgeList.forEach((bridge) => {
                if (bridge.id === this.routeBridgeId) {
                    routeBridgeIdConfirmed = true;
                    //break
                    return false;
                }
            });

            if (!routeBridgeIdConfirmed) {
                this.$alert("无效的桥梁编号", {
                    confirmButtonText: "确定",
                    showClose: true,
                    type: "error",
                    callback: (action) => {
                        // console.log('stop');
                        // this.resultObjectList = [];
                    },
                });

                return;
            }

            this.$http.get("/bridge/bridgeinfo?bridgeId=" + this.routeBridgeId).then((res) => {
                this.bridgeName = res.data.bridgeName;
                this.$nextTick(() => {
                    this.getSimpleHumidityListAndGetData();
                });

                this.timer = setInterval(() => {
                    this.getSimpleHumidityData();
                }, this.REFRESH_SECOND);
            })


        },
        refreshData() {
            for (let stationId in this.stationIdLoadingDict) {
                this.stationIdLoadingDict[stationId] = true;
            }

            this.$nextTick(() => {
                this.getSimpleHumidityData();
            })
        },
        currentChange(index) {
            this.pageLoading = true;
            this.currentPage = index;

            let result = [];
            let pageStart = (this.currentPage - 1) * this.pageSize;
            for (let i = 0; i < this.pageSize; i++) {
                let actualIndex = pageStart + i;
                if (actualIndex >= this.rowList_all.length) {
                    break;
                }

                result.push(this.rowList_all[actualIndex]);
            }

            this.rowList_current = result;

            setTimeout(() => {
                this.pageLoading = false;
            }, 500);
        },
        getSimpleHumidityListAndGetData() {
            this.pageLoading = true;
            let url = "/bridge/SimpleHumidityList?bridgeId=" + this.routeBridgeId;
            if (this.includePower === "true") {
                url += "&includePower=true";
            }
            this.$http.get(url).then((res) => {
                this.humidityGroupList = res.data.groupList;

                let stationIdLoadingDict = {};
                let itemIdSeriesDict = {};
                let deviceIdDataDict = {};
                let stationIdMergedStationIdListDict = {};
                let deviceIdItemNameDict = {};

                if (this.sortByItemCount) {
                    this.humidityGroupList.sort((a, b) => a.itemList.length - b.itemList.length);
                }

                this.humidityGroupList.forEach((groupItem) => {
                    stationIdLoadingDict[groupItem.stationId] = true;
                    if (!stationIdMergedStationIdListDict[groupItem.stationId]) {
                        stationIdMergedStationIdListDict[groupItem.stationId] = [];
                    }
                    if (groupItem.mergedStationIdList && groupItem.mergedStationIdList.length > 0) {
                        for (let mergedStationId of groupItem.mergedStationIdList) {
                            if (stationIdMergedStationIdListDict[groupItem.stationId].indexOf(mergedStationId) < 0) {
                                stationIdMergedStationIdListDict[groupItem.stationId].push(mergedStationId);
                            }
                        }
                    }

                    groupItem.itemList.forEach((humidityItem) => {
                        //device id data dict

                        if (humidityItem.deviceType === 'VALUE_SAME_LINE') {        
                            for (let deviceId in humidityItem.valueSameLineDeviceIdUnitDict) {
                                deviceIdDataDict[deviceId] = {
                                    data: "--",
                                    errorLevel: 'WARNING',
                                    unit: humidityItem.valueSameLineDeviceIdUnitDict[deviceId],
                                }
                            }
                            for (let deviceId in humidityItem.valueSameLineDeviceIdItemNameDict) {
                                deviceIdItemNameDict[deviceId] = humidityItem.valueSameLineDeviceIdItemNameDict[deviceId];
                            }
                        }
                        else if (humidityItem.deviceType === 'SWITCH') {
                            deviceIdDataDict[humidityItem.deviceId] = {
                                data: "--",
                                errorLevel: 'WARNING'
                            };
                        }
                        else if (humidityItem.deviceType === 'SWITCH_MALFUNCTION') {
                            deviceIdDataDict[humidityItem.deviceId] = {
                                data: "--",
                                errorLevel: 'WARNING',
                                isZh: true,
                            };
                        }

                        //item id series dict
                        if (humidityItem.deviceType === 'VALUE_SAME_LINE') {
                            itemIdSeriesDict[humidityItem.itemId] = [];
                            for (let deviceId in humidityItem.valueSameLineDeviceIdUnitDict) {
                                itemIdSeriesDict[humidityItem.itemId].push(deviceIdDataDict[deviceId]);
                            }
                        }
                        else if (humidityItem.deviceType === 'SWITCH') {
                            itemIdSeriesDict[humidityItem.itemId] = deviceIdDataDict[humidityItem.deviceId];
                        }
                        else if (humidityItem.deviceType === 'SWITCH_MALFUNCTION') {
                            itemIdSeriesDict[humidityItem.itemId] = deviceIdDataDict[humidityItem.deviceId];
                        }
                    })
                })

                this.stationIdLoadingDict = stationIdLoadingDict;
                this.itemIdSeriesDict = itemIdSeriesDict;
                this.deviceIdDataDict = deviceIdDataDict;
                this.deviceIdItemNameDict = deviceIdItemNameDict;
                this.stationIdMergedStationIdListDict = stationIdMergedStationIdListDict;

                this.$nextTick(() => {
                    this.pageLoading = false;
                })

                this.getSimpleHumidityData();
            });
        },
        getSimpleHumidityData() {
            for (let stationId in this.stationIdLoadingDict) {
                this.stationIdLoadingDict[stationId] = true;
            }

            this.$nextTick(() => {
                for (let stationId in this.stationIdMergedStationIdListDict) {
                    this.getSimpleHumidityDataForStation(stationId, this.stationIdMergedStationIdListDict[stationId]);
                }
            })
        },
        getSimpleHumidityDataForStation(stationId, mergedStationIdList) {
            let requestList = [this.$http.get("/deviceData/Station?stationId=" + stationId)];
            for (let mergedStationId of mergedStationIdList) {
                requestList.push(this.$http.get("/deviceData/Station?stationId=" + mergedStationId))
            }

            this.$http.all(requestList).then(
                this.$http.spread((...resList) => {
                    for (let res of resList) {
                        for (let deviceId in res.data) {
                            if (!this.deviceIdDataDict[deviceId]) {
                                continue;
                            };

                            let deviceValue = res.data[deviceId];
                            this.deviceIdDataDict[deviceId].data = deviceValue.value;
                            this.deviceIdDataDict[deviceId].isError = deviceValue.errorLevel;

                            //name + value too long
                            // let deviceValue = res.data[deviceId];
                            // let itemValue = deviceValue.value;
                            // if (this.deviceIdItemNameDict[deviceId] && itemValue) {
                            //     itemValue = this.deviceIdItemNameDict[deviceId] + itemValue;
                            // }

                            // this.deviceIdDataDict[deviceId].data = itemValue;
                            // this.deviceIdDataDict[deviceId].isError = deviceValue.errorLevel;

                        }
                    }

                    this.$nextTick(() => {
                        this.stationIdLoadingDict[stationId] = false;
                    })
                })
            )
        },
        translateBridgeName(bridgeId) {
            for (let bridge of this.bridgeList) {
                if (bridge.id === bridgeId) {
                    return bridge.name;
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.humidity-list-room {
    padding-top: 10px;
    padding-bottom: 10px;

    .room-title {
        font-weight: bold;
        font-size: 28px;

        display: flex;
        align-items: center;
        justify-content: space-evenly;

        margin-bottom: 10px;

        span {
            background-color: rgba(255, 255, 255, 0.6);
            padding-left: 15px;
            padding-right: 15px;
            // display: inline-block;
        }
    }

    .humidity-list-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        align-items: flex-start;
    }

    .humidity-list-group {
        min-width: 340px;
        margin: 5px;
        margin-bottom: 10px;
        width: calc(17% - 5px);
        border: 2px solid #dfe4ea;
        border-radius: 10px;
    }

    .humidity-group-name {
        height: 35px;
        width: calc(100% - 10px);
        box-sizing: border-box;
        margin: 5px 5px 5px 5px;
        flex-shrink: 0;

        font-weight: bold;
        font-size: 18px;

        display: flex;
        align-items: center;
        justify-content: space-evenly;

        background-color: rgba(255, 255, 255, 0.6);
    }

    .humidity-list-item {
        height: 30px;
        width: calc(100% - 10px);
        box-sizing: border-box;
        margin: 5px 5px 5px 5px;
        flex-shrink: 0;

        background-color: rgba(255, 255, 255, 0.6);
    }

    ::v-deep .switch-status {
        background-color: transparent;
        height: 30px;
    }

    ::v-deep .double-value-switch.switch-status {
        :first-child {
            max-width: calc(100% - 125px);
        }
    }

    ::v-deep .single-value-switch.switch-status {
        :first-child {
            max-width: calc(100% - 65px);
        }
    }
}

.status-tag {
    cursor: pointer;
}

.table-button {
    margin-bottom: 10px;
    margin-left: 10px;
}

.dialog-form-input {
    width: 80%;
}

.error-level-tag {
    min-width: 75px;
}
</style>
